import Modals from 'root/modals';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    className: 'session-replay-recent',

    events: {
        'click': 'onOpen'
    },

    dom_handlers: {
        onOpen: function(e) {
            Modals.openSessionRecording(this.model.id);
        }
    },

    initialize: function(options) {
        this.listenTo(this.model, 'change', this.render);
    },

    render: function() {
        var duration = this.model.getDuration();
        var tags = '';

        if (this.model.get('tag')) {
            this.model.get('tag').split(',').forEach(function(tag) {
                tags += '<span class="text-primary text-small font-weight-medium">#' + Util.htmlEntities(tag) + '</span> ';
            });
        }

        var seconds_diff = Util.secondsDiff(this.model.get('timestamp') + this.model.get('duration'));

        var content =
        '<div class="flex-between">' +
            '<div class="text-info text-medium font-weight-medium">' + this.model.escape('domain') + '</div>' +
            '<div class="text-info text-medium">' + Util.moment(this.model.escape('timestamp')) + '</div>' +
        '</div>' +
        '<div class="text-default flex-start font-weight-medium margin-top-8">' +
            '<span class="session-location">' + (this.model.get('location') || 'Unknown location') + '</span>' +
            '<span class="session-duration">' +
                (duration === '00:00' ? '--:--</span>' : duration) +
                (seconds_diff <= 120 ? '<span class="session-online tooltip" data-title="Online"></span>' : '') +
            '</span>' +
        '</div>' +
        (tags ?
        '<div class="margin-top-8">' + tags + '</div>' : '');

        this.$el.html(content);

        return this;
    }
});